import { useVersionWallParameterStore } from './useVersionWallStore'

export const UpdatesStatsigStore = {
  useVersionWallParameterStore,
}
